import React, { PureComponent, Fragment } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Button, Divider } from "semantic-ui-react";

import AddUserToResourceForm from "./AddUserToResourceForm.jsx";
import AddExistingUserToResourceForm from "./AddExistingUserToResourceForm.jsx";
import withBasicForm from "../forms/withBasicForm.js";

import { selectCopy } from "../../state/reducers/locale/copySelector.js";

const BasicAddUserToResourceForm = withBasicForm(AddUserToResourceForm);
const BasicAddExistingUserToResourceForm = withBasicForm(
  AddExistingUserToResourceForm
);

class AddUserToResourcePanel extends PureComponent {
  static propTypes = {
    data: PropTypes.object.isRequired,
    onSubmit: PropTypes.func.isRequired,
    useInviteByExistingUser: PropTypes.bool.isRequired,
    copyKey: PropTypes.string.isRequired,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    copyKey: "users.user_panel",
    useInviteByExistingUser: false
  };

  state = {
    showForm: false,
    inviteUserByEmail: true
  };

  // -- HANDLERS -- //

  onInviteNewUser = () => {
    this.setState({ showForm: true });
  };

  onInviteByEmail = (evt, data) => {
    this.setState({ inviteUserByEmail: true });
  };

  onInviteByExistingUser = (evt, data) => {
    this.setState({ inviteUserByEmail: false });
  };

  onCancel = () => {
    this.setState({ showForm: false });
  };

  // -- RENDER -- //

  render() {
    const { data, onSubmit, useInviteByExistingUser, copyKey, copy } =
      this.props;
    const { showForm, inviteUserByEmail } = this.state;

    if (!showForm) {
      return (
        <Fragment>
          <Button
            onClick={this.onInviteNewUser}
            icon="plus circle"
            content={copy(`${copyKey}.add_cta`)}
            className="add-resource-cta"
            type="button"
            floated="right"
          />
          <Divider fitted clearing hidden />
        </Fragment>
      );
    }

    if (inviteUserByEmail) {
      const inviteByExistingUser = useInviteByExistingUser
        ? this.onInviteByExistingUser
        : undefined;

      return (
        <BasicAddUserToResourceForm
          groups={data.groups}
          entity={data}
          onSubmit={onSubmit}
          onReset={() => {}}
          onCancel={this.onCancel}
          onInviteByExistingUser={inviteByExistingUser}
        />
      );
    }

    return (
      <BasicAddExistingUserToResourceForm
        groups={data.groups}
        entity={data}
        onSubmit={onSubmit}
        onReset={() => {}}
        onCancel={this.onCancel}
        onInviteByEmail={this.onInviteByEmail}
      />
    );
  }
}

const mapStateToProps = state => ({
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(AddUserToResourcePanel);
